/* @flow */

import jQuery from 'jquery';
import modalVisualizacao from './modal-visualizacao';

type Param = {
    titulo: string,
    tamanho?: 'lg' | 'md' | 'sm',
    texto?: string,
    sim?: string,
    nao?: string,
    timeout?: number,
    focarNoConfirmar?: boolean,
}

const modalConfirmacao = (valores: Param): Promise<null> => new Promise((resolve, reject) => {
    const $ = global.$ || jQuery;

    const {
        titulo,
        tamanho = 'sm',
        sim = 'Sim',
        nao = 'Não',
        timeout = 5000,
        focarNoConfirmar,
    } = valores;

    let rodape = `
        <button
            type="button"
            id="modal-confirmacao-nao"
            class="btn btn-default"
        >
            ${nao}
        </button>
        <button
            type="button"
            id="modal-confirmacao-sim"
            class="btn btn-success"
        >
            ${sim}
        </button>
    `;

    let { texto } = valores;
    if (!texto) {
        texto = rodape;
        rodape = '';
    }

    modalVisualizacao({
        titulo,
        tamanho,
        texto,
        rodape,
    });

    const timer = setTimeout(() => {
        // $FlowFixMe
        $('#modal-padrao').modal('hide');
    }, timeout);

    $('#modal-padrao').one('hide.bs.modal', () => {
        clearTimeout(timer);
        reject();
    });

    if (focarNoConfirmar) {
        $('#modal-padrao').one('shown.bs.modal', () => {
            const botaoConfirmacao = document.getElementById('modal-confirmacao-sim');
            if (botaoConfirmacao) {
                botaoConfirmacao.focus();
            }
        });
    }

    $('#modal-confirmacao-sim').one('click', () => {
        resolve(null);
        // $FlowFixMe
        $('#modal-padrao').modal('hide');
    });

    $('#modal-confirmacao-nao').one('click', () => {
        reject();
        // $FlowFixMe
        $('#modal-padrao').modal('hide');
    });
});

export default modalConfirmacao;
